import React, { useState } from 'react';
import { Brikk } from 'components/Brikk';
import internationalCitizensHub from 'assets/media/international-citizens-hub.jpg';
import Draggable from 'components/drag-and-drop/Draggable';
import { NewPageButton } from 'components/form-elements/buttons/NewPageButton';
import { GlobeIcon } from 'assets/icons/brikks/GlobeIcon';
import { LinkBrikkContent } from 'components/brikks/sub-components/LinkBrikkContent';
import { CircularImage } from 'components/brikks/sub-components/CircularImage';
import { BrikkInfoModal } from 'components/modals/BrikkInfoModal';
import { InfoButton } from 'components/form-elements/buttons/InfoButton';

export const CitizensHub = ({ position, status, code, name }) => {
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  const handleInfoModal = (e) => {
    e.stopPropagation();
    setIsInfoModalOpen(!isInfoModalOpen);
  };
  return (
    <>
      <Draggable position={position}>
        <Brikk
          brikkKey={code}
          name={name}
          status={status}
        >
          <Brikk.Header
            icon={<GlobeIcon />}
            heading="citizenHubBrikk"
            brikkKey={code}
            status={status}
          />

          <Brikk.Content>
            <CircularImage
              src={internationalCitizensHub}
              alt="Lund International Citizens Hub Logo"
            />

            <LinkBrikkContent link="internationalcitizenhub.com" />
          </Brikk.Content>

          <Brikk.Button>
            <NewPageButton
              label="International Citizens Hub Link"
              to="https://internationalcitizenhub.com/"
              brikkNameIntl="ICH"
            />
            <InfoButton
              showModal={isInfoModalOpen}
              onClick={handleInfoModal}
            />
          </Brikk.Button>
        </Brikk>
      </Draggable>
      <BrikkInfoModal
        title="CitizensHub info"
        // info={info}
        showModal={isInfoModalOpen}
        onClick={() => setIsInfoModalOpen(!isInfoModalOpen)}
      />
    </>
  );
};
